import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import api from '../../api';
import DashboardLayout from './DashboardLayout';

function Step2Form() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'code-block',
    'list',
    'bullet',
    'link',
    'image',
  ];

  const handleSubmit = async e => {
    e.preventDefault();

    if (!content.trim()) {
      toast.error('Content cannot be empty');
      return;
    }

    setLoading(true);

    try {
      await api.put(`/articles/step2/${id}`, { content });
      toast.success('Article published successfully!');
      setTimeout(() => navigate('/alist'), 1500);
    } catch (err) {
      console.error('Error updating content:', err);
      toast.error(err.response?.data?.error || 'Failed to update content');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <form onSubmit={handleSubmit} className="p-4 max-w-3xl mx-auto bg-white rounded shadow">
        <h2 className="text-xl font-bold mb-4">Step 2: Add Content</h2>

        <div className="mb-4">
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            modules={modules}
            formats={formats}
            placeholder="Write your article content here..."
            style={{ minHeight: '300px', marginBottom: '20px' }}
          />
        </div>

        <button
          type="submit"
          className="mt-4 bg-green-600 text-white px-6 py-2 rounded"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Publishing...
            </>
          ) : (
            'Publish'
          )}
        </button>
      </form>
    </DashboardLayout>
  );
}

Step2Form.propTypes = {};

export default Step2Form;
